"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var _react = require("react");
var _Modal = require("@mui/base/Modal");
var _classVarianceAuthority = require("class-variance-authority");
var _base = require("@mui/base");
var _helpers = require("../../common/helpers");
var _Button = require("../Button");
var _Card = require("../Card");
var _Icon = require("../Icon");
var _Transition = require("../Transition");
var _classes = require("../../common/classes");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["open", "ownerState"],
  _excluded2 = ["width", "className", "open", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var rootClasses = (0, _classVarianceAuthority.cva)(['fixed', 'z-[1300]', 'inset-0', 'overflow-y-scroll']);
var containerClasses = (0, _classVarianceAuthority.cva)(['min-h-full', 'flex', 'items-center', 'justify-center', 'pointer-events-none']);
var cardClasses = (0, _classVarianceAuthority.cva)(['relative', 'm-5', 'p-10', 'w-[calc(100%-2rem)]', 'pointer-events-auto'], {
  variants: {
    width: {
      auto: ['container'],
      xs: ['max-w-screen-xs'],
      sm: ['max-w-screen-sm'],
      md: ['max-w-screen-md'],
      lg: ['max-w-screen-lg'],
      xl: ['max-w-screen-xl']
    }
  }
});
var closeClasses = (0, _classVarianceAuthority.cva)(['absolute', 'right-3', 'top-3']);
var Backdrop = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var open = _ref.open,
    ownerState = _ref.ownerState,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Transition.Transition, {
    "in": open,
    type: "fade",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
      ref: ref
    }, props), {}, {
      className: (0, _helpers.cn)((0, _classes.backdropClasses)())
    }))
  });
});

/**
 * Modal - [API](https://reimagined-adventure-37999z9.pages.github.io/?path=/docs/feedback-modal)
 */
var Modal = exports.Modal = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? 'auto' : _ref2$width,
    className = _ref2.className,
    open = _ref2.open,
    children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.ClassNameConfigurator, {
    disableDefaultClasses: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref,
      open: open,
      slots: {
        backdrop: Backdrop
      },
      slotProps: {
        root: {
          className: (0, _helpers.cn)(rootClasses())
        },
        backdrop: {
          className: (0, _helpers.cn)((0, _classes.backdropClasses)())
        }
      },
      closeAfterTransition: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: containerClasses(),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Transition.Transition, {
          "in": open,
          type: "grow",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.Card, {
            className: (0, _helpers.cn)(cardClasses({
              width: width,
              className: className
            })),
            children: [props.onClose && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
              color: "transparent",
              size: "sm",
              shape: "circle",
              className: (0, _helpers.cn)(closeClasses()),
              onClick: props.onClose,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                icon: "xmark-large",
                title: "Close",
                size: "lg"
              })
            }), children]
          })
        })
      })
    }))
  });
});